<script setup lang="ts">
defineProps<{
  resultCount?: number
}>()

const t = useTranslator()

const isMac = computed(() => typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent))

const hints = computed(() => [
  { keys: ['↑', '↓'], label: t('CHROME_SEARCH_NAVIGATE') },
  { keys: ['↵'], label: t('CHROME_SEARCH_OPEN') },
  { keys: ['Esc'], label: t('CHROME_SEARCH_CLOSE') },
  { keys: [isMac.value ? '⌘' : 'Ctrl', 'K'], label: t('CHROME_SEARCH_OPEN_CLOSE') },
])
</script>

<template>
  <div class="border-t border-border px-4 py-2 flex items-center gap-4 shrink-0 bg-muted/20">
    <div v-for="(hint, i) in hints" :key="i" class="flex items-center gap-1.5">
      <div class="flex items-center gap-0.5">
        <kbd
          v-for="k in hint.keys"
          :key="k"
          class="h-4.5 px-1 border border-border text-[0.625rem] text-muted-foreground/50 font-mono bg-background flex items-center"
        >
          {{ k }}
        </kbd>
      </div>
      <span class="text-[0.656rem] text-muted-foreground/40">{{ hint.label }}</span>
    </div>
    <span v-if="resultCount" class="ml-auto text-[0.656rem] text-muted-foreground/30">
      {{ resultCount }} {{ resultCount === 1 ? t('CHROME_SEARCH_RESULT') : t('CHROME_SEARCH_RESULTS') }}
    </span>
  </div>
</template>
